import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import { out } from "@/lib/output/out";
import type { ApiOutputs } from "@/lib/api/api-outputs";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

export async function listCatalogModels(
  parsed: ParsedArgs,
  asJson: boolean,
): Promise<void> {
  args.expect(parsed, {});
  const result = expectShape<ApiOutputs["catalog"]["models"]>(
    await api("/models"),
    "GET /models",
    { harnesses: is.array, gatewayModels: is.array },
  );
  if (asJson) {
    out.json(result);
    return;
  }
  out.line(out.paint("harnesses", "dim"));
  for (const harness of result.harnesses) {
    out.line(`  ${out.cell(harness)}`);
  }
  out.line();
  out.line(out.paint("gateway models", "dim"));
  for (const model of result.gatewayModels) {
    out.line(`  ${out.cell(model.id)}`);
  }
}
